import { css } from 'lit';
import { nightGlobalStyles } from './night-global-styles'
import { defaultGlobalStyles } from './default-global-styles';

export enum StyleName {
    default = "day",
    dusk = "dusk",
    night = "night",
    legacyDefault = "default"
}

export const VoyageStyle = new class extends EventTarget
{
    constructor()
    {
        super();
        this._loadStyles();
        this.applyGlobalStyles(this._currentStyle);
    }

    get currentStyle(): StyleName
    {
        return this._currentStyle;
    }

    applyGlobalStyles(styleName: StyleName)
    {
        let styles;

        switch (styleName)
        {
            case StyleName.dusk:
            // Use the night style with dusk for now (map will still be slightly lighter)
            styles = nightGlobalStyles;
            break;
                
            case StyleName.night:
            styles = nightGlobalStyles;
            break;
            
            default:
            styles = defaultGlobalStyles;
            break;
        }

        const styleElement = document.createElement("style");
        styleElement.textContent = styles.cssText;

        if (this._globalStyleElement)
        {
            this._globalStyleElement.remove();
        }

        document.head.appendChild(styleElement);
        this._globalStyleElement = styleElement;

        this._currentStyle = styleName;
        this._saveStyles();
        this.dispatchEvent(new Event("styles-changed"));
    }

    private _globalStyleElement: HTMLStyleElement|null = null;
    private _currentStyle: StyleName = StyleName.default;

    private _loadStyles()
    {
        const defaultStyle = (<any>window)["appenv"].featureToggles.encTileServer ? StyleName.default : StyleName.legacyDefault;
        
        try {
            let savedStyle:string | null = localStorage.getItem('voyage-style');
            if (savedStyle === "default") {
                savedStyle = defaultStyle;
            }

            if (savedStyle && savedStyle in StyleName) {
                this._currentStyle = <StyleName>savedStyle;
            }
            else {
                this._currentStyle = defaultStyle;            
            }
        } catch {
            this._currentStyle = defaultStyle;
        }
    }

    private _saveStyles()
    {
        localStorage.setItem('voyage-style', this._currentStyle);
    }
};

export const voyageRadioButtonsStyle = css`
    input[type="radio"] {
        margin: 0;
        position: relative;
        justify-self: center;
        -webkit-appearance: none;
        width: 16px;
        height: 16px;
        border: 1px solid var(--neutrals-grey-06, grey);
        border-radius: 8px;
    }

    input[type="radio"]:disabled {
        opacity: 0.5;
    }

    input[type="radio"]:checked::after {
        content: "";
        position: absolute;
        top: 2px;
        left: 2px;
        right: 2px;
        bottom: 2px;
        background-color: var(--primary-blue-05, blue);
        border-radius: 5px;
    }
`;

export const voyageCursorStyles = css`
    button,
    select,
    input::-webkit-calendar-picker-indicator,
    input[type=file], 
    input[type=file]::-webkit-file-upload-button,
    input[type=checkbox],
    input[type=radio],
    input::-webkit-inner-spin-button
    {
        cursor: pointer;
    }

    input[type=text],
    input::-webkit-datetime-edit-fields-wrapper,
    input::-webkit-datetime-edit {
        cursor: text;
    }
    
    input:disabled,
    button:disabled,
    select:disabled  {
        cursor: not-allowed;
    } 
`;
